
import { z } from "zod";
import { AIUseCaseSummary, BusinessContext, IntendedUse, UseCaseDataContext, AISystemContext, UseCase, DataContext } from "../UseCase";
import type { AssertSchemaMatchesClass } from "../../../utils/typeUtils";

const _AIUseCaseSummaryZod = z.object({
    useCaseTitle: z.string().default(""),
    useCaseSummary: z.string().default(""),
    useCaseOwner: z.string().default(""),
    department: z.string().default(""),
    adoptionStage: z.string().default(""),
})
// Assert that schema matches the class definition
void (true as AssertSchemaMatchesClass<typeof _AIUseCaseSummaryZod, AIUseCaseSummary>);
export const AIUseCaseSummarySchema = _AIUseCaseSummaryZod.transform((data) => new AIUseCaseSummary(data));


const _BusinessContextZod = z.object({
    businessCriticality: z.string().default(""),
    applicableSectors: z.string().default(""),
    deploymentRegions: z.string().default(""),
    impactedNationalities: z.string().default(""),
    humanInTheLoop: z.string().default(""),
    maintenanceApproach: z.string().default("")
})
// Assert that schema matches the class definition
void (true as AssertSchemaMatchesClass<typeof _BusinessContextZod, BusinessContext>);
export const BusinessContextSchema = _BusinessContextZod.transform((data) => new BusinessContext(data));


const _IntendedUseZod = z.object({
    intendedUsers: z.string().default(""),
    useCaseScenarios: z.string().default(""),
    accessibleBy: z.string().default(""),
    systemFeatures: z.string().default("")
})
// Assert that schema matches the class definition
void (true as AssertSchemaMatchesClass<typeof _IntendedUseZod, IntendedUse>);
export const IntendedUseSchema = _IntendedUseZod.transform((data) => new IntendedUse(data));


const _DataContextZod = z.object({
    dataContentDescription: z.string().default(""),
    dataFormats: z.string().default(""),
    dataSources: z.string().default(""),
    dataSensitivity: z.string().default(""),
    personalData: z.string().default(""),
    dataOwnership: z.string().default(""),
    dataResidency: z.string().default("")
})
// Assert that schema matches the class definition
void (true as AssertSchemaMatchesClass<typeof _DataContextZod, DataContext>);
export const DataContextSchema = _DataContextZod.transform((data) => new DataContext(data));


const _UseCaseDataContextZod = z.object({
    training: DataContextSchema.default(new DataContext()),
    input: DataContextSchema.default(new DataContext()),
    output: DataContextSchema.default(new DataContext())
})
// Assert that schema matches the class definition
void (true as AssertSchemaMatchesClass<typeof _UseCaseDataContextZod, UseCaseDataContext>);
export const UseCaseDataContextSchema = _UseCaseDataContextZod.transform((data) => new UseCaseDataContext(data));


const _AISystemContextZod = z.object({
    aiCapabilities: z.string().default(""),
    aiModels: z.string().default(""),
    softwareComponents: z.string().default(""),
    deploymentEnvironment: z.string().default("")
})
// Assert that schema matches the class definition
void (true as AssertSchemaMatchesClass<typeof _AISystemContextZod, AISystemContext>);
export const AISystemContextSchema = _AISystemContextZod.transform((data) => new AISystemContext(data));  


const _UseCaseZod = z.object({
    id: z.string().default(""),
    useCaseSummary: AIUseCaseSummarySchema.default(new AIUseCaseSummary()),
    businessContext: BusinessContextSchema.default(new BusinessContext()),
    intendedUse: IntendedUseSchema.default(new IntendedUse()),
    dataContext: UseCaseDataContextSchema.default(new UseCaseDataContext()),
    systemComponents: AISystemContextSchema.default(new AISystemContext())
})
// Assert that schema matches the class definition
void (true as AssertSchemaMatchesClass<typeof _UseCaseZod, UseCase>);
export const UseCaseSchema = _UseCaseZod.transform((data) => new UseCase(data));



